export default "__VITE_ASSET__ChXQ$o2E__"